// React Imports
import { ReactElement, useState } from "react";

// Third Party Libraries Imports
import { ReactSVG } from "react-svg";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { Link, NavigateFunction, useNavigate } from "react-router-dom";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import CustomTable from "../../components/custom-table/custom-table";
import CustomSearch from "../../components/custom-search/custom-search";
import CustomModal from "../../components/custom-modal/custom-modal";
import DeleteModal from "../../components/delete-modal/delete-modal";

const Banks: React.FC = (): ReactElement => {
  const navigate: NavigateFunction = useNavigate()
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Name En",
      dataIndex: "nameEn",
      key: "nameEn",
      sorter: (a, b) => a.nameEn.length - b.nameEn.length,
      fixed: "left",
    },
    {
      title: "Name Ar",
      dataIndex: "nameAr",
      key: "nameAr",
      sorter: (a, b) => a.nameAr.length - b.nameAr.length,
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      sorter: (a, b) => a.currency.length - b.currency.length,
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      sorter: (a, b) => a.country.length - b.country.length,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      render: () => (
        <div className="flex items-center gap-3">
          <ReactSVG src={"/images/edit.svg"} onClick={() => navigate('/banks/add?edit=1')} />
          <ReactSVG
            className="delete-icon"
            src={"/images/delete.svg"}
            onClick={() => setOpenDeleteModal(true)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between flex-wrap">
        <BreadcrumbComponent />
        <Link
          to={"/banks/add"}
          className="flex items-center justify-center bg-blue-500 rounded-[20px] py-[10px] px-[25px] text-white border-0 cursor-pointer mb-5 decoration-transparent"
        >
          <img className=" me-2" src={'/images/white-add-square.svg'} alt="add-fund kamco" />
          <span>Add Bank</span>
        </Link>
      </div>
      <div className="mt-5 border-[1px] border-gray-400 rounded-lg">
        <div className="flex items-center justify-between rounded-t-lg rounded-e-lg bg-white py-[10px] px-5">
          <p className=" text-black-300 text-base font-semibold">2 Banks</p>
          <div className="flex items-center">
            <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
          </div>
        </div>
        <CustomTable columns={columns} data={[]} />
      </div>

      <CustomModal
        isVisible={openDeleteModal}
        centered
        width={450}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenDeleteModal(false)}
          text="Delete bank!"
          subText="Are you sure you want to delete this bank?"
        />
      </CustomModal>
    </div>
  );
};

export default Banks;
